// extracted by mini-css-extract-plugin
export default {"iconLanguage":"iconLanguage_xrmG"};